class FnsApi {
  constructor(host, headers) {
    this._host = host;
    this._headers = headers;
  }

  _getResOrError(res){
    if (res.ok){
      return res.json();
    }
    throw new Error('Ошибка при загрузке данных');
  }

  getFirmBo(firm) {
    // console.log(`${this._host}/bo?${firm}`);
    return fetch(`${this._host}/bo?${firm}`, {
      method: 'GET',
      headers: this._headers,
    })
      .then(this._getResOrError);
  }

  getFirmEgr(firm) {
    return fetch(`${this._host}/egr?${firm}`, {
      method: 'GET',
      headers: this._headers,
    })
      .then(this._getResOrError);
  }
}

export const fnsApi = new FnsApi('https://api-fns.ru/api', {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
});
